import React, { useState, useEffect } from 'react'
import styles from './styles.module.css'
import useStore from "../../../StorePeople/Store";

export default function City() {
  const { city, setCity ,isQueryLoading } = useStore();
  // Local state to immediately reflect the input value
  const [localCity, setLocalCity] = useState(city)

  // Update the global city only after 1 second of no changes
  useEffect(() => {
    const timer = setTimeout(() => {
      setCity(localCity)
    }, 1000)

    // Clear the timeout if the user types again before 1 second passes
    return () => clearTimeout(timer)
  }, [localCity, setCity])

  // Synchronize local state when the global city changes externally
  useEffect(() => {
    setLocalCity(city)
  }, [city])

  const handleCityChange = (event) => {
    setLocalCity(event.target.value)
  }

  return (
    <div className={styles.cityPeopleContainer}>
      <label className={styles.cityPeopleLabel}>City</label>
      <input
        className={styles.cityInputPeople}
        type='text'
        id='prevent_autofill'
        autoComplete='off'
        placeholder='San francisco'
        value={localCity}
        disabled={isQueryLoading}
        onChange={handleCityChange}
      />
    </div>
  )
}
